import { createSelector } from 'reselect';

const getState = (state) => state.directOrderRecurring.quote;

const getQuote = createSelector(getState, (quote) => quote.quote);

const getQuoteError = createSelector(getState, (quote) => quote.hasError);

const getQuoteErrorType = createSelector(getState, (quote) => quote.errorType);

export default {
  getQuote,
  getQuoteError,
  getQuoteErrorType,
};
